import React from 'react';

function VoucherTaxSummary({ itemList }) {
    if (!itemList || itemList.length === 0) return null;

    // Process and group items safely by BOTH HSN Code and GST Rate
    const processTaxSummary = () => {
        const summaryMap = {};

        itemList.forEach(item => {
            const hsn = item.hsn ? item.hsn.trim().toUpperCase() : 'N/A';
            const gstRate = Number(item.gstRate || 0);
            const taxableAmount = Number(item.amount || 0);
            const gstAmount = Number(item.gstAmount || 0);
            const qty = Number(item.qty || 0);

            // Create a compound key combining HSN and GST Rate to protect against multi-slab HSN numbers
            const groupKey = `${hsn}_${gstRate}`;

            if (!summaryMap[groupKey]) {
                summaryMap[groupKey] = {
                    hsn: hsn,
                    gstRate: gstRate,
                    itemCount: 0,
                    totalQty: 0,
                    totalTaxable: 0,
                    totalTax: 0
                };
            }

            summaryMap[groupKey].itemCount += 1;
            summaryMap[groupKey].totalQty += qty;
            summaryMap[groupKey].totalTaxable += taxableAmount;
            summaryMap[groupKey].totalTax += gstAmount;
        });

        // Convert grouped object map back into a sorted array (highest tax slab first)
        return Object.values(summaryMap).sort((a, b) => b.gstRate - a.gstRate);
    };

    const taxSummaryList = processTaxSummary();

    // Calculate aggregated totals for the table footer summary layout
    const totals = taxSummaryList.reduce((acc, current) => {
        return {
            items: acc.items + current.itemCount,
            qty: acc.qty + current.totalQty,
            taxable: acc.taxable + current.totalTaxable,
            tax: acc.tax + current.totalTax
        };
    }, { items: 0, qty: 0, taxable: 0, tax: 0 });

    return (
        <div className="card mt-3 border shadow-sm">
            <div className="card-header bg-light py-0">
                <span className="fw-bold text-secondary text-uppercase tracking-wider" style={{ fontSize: 11, }}>
                    HSN / GST Tax Slab Summary Breakdown
                </span>
            </div>
            <div className="card-body p-0">
                <table className="table table-sm table-bordered mb-0 text-center align-middle" style={{ fontSize: 12 }}>
                    <thead className="table-light text-secondary fw-semibold">
                        <tr>
                            <th>HSN/SAC Code</th>
                            <th>GST Slab Rate</th>
                            <th>Item Lines Count</th>
                            <th>Total Quantity</th>
                            <th className="text-end pe-3">Taxable Value (₹)</th>
                            <th className="text-end pe-3">Calculated Tax (₹)</th>
                            <th className="text-end pe-3">Gross Total (₹)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {taxSummaryList.map((row, index) => (
                            <tr key={index}>
                                <td className="fw-bold text-dark">{row.hsn}</td>
                                <td>
                                    <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-2 py-1">
                                        {row.gstRate}%
                                    </span>
                                </td>
                                <td>
                                    {row.itemCount} {row.itemCount === 1 ? 'Item' : 'Items'}
                                </td>
                                <td>{row.totalQty}</td>
                                <td className="text-end pe-3">{row.totalTaxable.toFixed(2)}</td>
                                <td className="text-end pe-3 text-danger">{row.totalTax.toFixed(2)}</td>
                                <td className="text-end pe-3 fw-semibold text-dark">
                                    {(row.totalTaxable + row.totalTax).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="table-light fw-bold border-top border-2">
                        <tr>
                            <td colSpan={2} className="text-end text-uppercase text-secondary" style={{ fontSize: 11 }}>Summary Totals:</td>
                            <td>{totals.items} Rows</td>
                            <td>{totals.qty}</td>
                            <td className="text-end pe-3">{totals.taxable.toFixed(2)}</td>
                            <td className="text-end pe-3 text-danger">{totals.tax.toFixed(2)}</td>
                            <td className="text-end pe-3 text-primary">
                                {(totals.taxable + totals.tax).toFixed(2)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
}

export default VoucherTaxSummary;